(() => {
  const enhanceTables = (root = document) => {
    root.querySelectorAll('[data-mm-article-content]').forEach((body) => {
      body.querySelectorAll('table').forEach((table, index) => {
        if (table.parentElement.classList.contains('mm-article__table-scroll')) return;
        const region = document.createElement('div');
        region.className = 'mm-article__table-scroll';
        region.tabIndex = 0;
        region.setAttribute('role', 'region');
        region.setAttribute('aria-label', `Article table ${index + 1}. Scroll horizontally if needed.`);
        table.before(region);
        region.append(table);
      });
    });
  };
  enhanceTables();
  document.addEventListener('shopify:section:load', (event) => enhanceTables(event.target));
})();
